import React from 'react';
import Chip from '@mui/material/Chip';
import Avatar from '@mui/material/Avatar';
import CheckSharpIcon from '@mui/icons-material/CheckSharp';
import PriorityHighSharpIcon from '@mui/icons-material/PriorityHighSharp';
import GpsFixedSharpIcon from '@mui/icons-material/GpsFixedSharp';
import FiberManualRecordSharpIcon from '@mui/icons-material/FiberManualRecordSharp';

export const TrendingChip = (props) => {
  const { label = '' } = props;
  const labelType = label?.toLowerCase();
  switch (labelType) {
    case 'high':
      return (
        <Chip
          label={label}
          size={'small'}
          sx={{
            border: '1px solid',
            color: '#EC7A81',
            backgroundColor: (theme) => theme.palette.chipBackground.high,
            p: '0px 6px',
            fontSize: '12px',
          }}
        />
      );
    case 'medium':
      return (
        <Chip
          label={label}
          size={'small'}
          sx={{
            border: '1px solid',
            color: '#FFA747',
            backgroundColor: (theme) => theme.palette.chipBackground.medium,
            p: '0px 6px',
            fontSize: '12px',
          }}
        />
      );
    case 'low':
      return (
        <Chip
          label={label}
          size={'small'}
          sx={{ border: '1px solid', color: '#33B784', backgroundColor: (theme) => theme.palette.chipBackground.low, p: '0px 6px', fontSize: '12px' }}
        />
      );
    case 'mild':
      return (
        <Chip
          label={label}
          size={'small'}
          sx={{
            border: '1px solid',
            color: '#1E97B9',
            backgroundColor: (theme) => theme.palette.chipBackground.mild,
            p: '0px 6px',
            fontSize: '12px',
          }}
        />
      );
    default:
      return (
        <Chip
          label={label}
          size={'small'}
          sx={{
            border: '1px solid',
            color: '#33B784',
            backgroundColor: (theme) => theme.palette.chipBackground.default,
            p: '0px 6px',
            fontSize: '12px',
          }}
        />
      );
  }
};

export const StatusChip = (props) => {
  const { label = '' } = props;
  const labelType = label.toLowerCase();
  switch (labelType) {
    case 'healthy':
      return (
        <Chip
          avatar={
            <Avatar sx={{ backgroundColor: (theme) => theme.palette.success.main }}>
              <CheckSharpIcon sx={{ color: '#34373E' }} />
            </Avatar>
          }
          label={label}
          sx={{ '& .MuiChip-label': { color: (theme) => theme.palette.gray50 }, background: (theme) => theme.palette.background.light7 }}
        />
      );
    case 'unknown':
    case 'inactive':
      return (
        <Chip
          avatar={
            <Avatar sx={{ backgroundColor: '#6B7280' }}>
              <FiberManualRecordSharpIcon sx={{ color: '#34373E' }} />
            </Avatar>
          }
          label={label}
          sx={{ '& .MuiChip-label': { color: (theme) => theme.palette.gray50 }, background: (theme) => theme.palette.background.light7 }}
        />
      );
    case 'unhealthy':
    case 'attention':
      return (
        <Chip
          avatar={
            <Avatar sx={{ backgroundColor: (theme) => theme.palette.error.main }}>
              <PriorityHighSharpIcon sx={{ color: '#34373E' }} />
            </Avatar>
          }
          label={label}
          sx={{ '& .MuiChip-label': { color: (theme) => theme.palette.gray50 }, background: (theme) => theme.palette.background.light7 }}
        />
      );
    case 'monitor':
      return (
        <Chip
          avatar={
            <Avatar sx={{ backgroundColor: (theme) => theme.palette.warning.main }}>
              <GpsFixedSharpIcon sx={{ color: '#34373E' }} />
            </Avatar>
          }
          label={label}
          sx={{ '& .MuiChip-label': { color: (theme) => theme.palette.gray50 }, background: (theme) => theme.palette.background.light7 }}
        />
      );
    default:
      return <Chip avatar={<Avatar sx={{ backgroundColor: (theme) => theme.palette.success.main }}>M</Avatar>} label={label} />;
  }
};

export const StatesChip = (props) => {
  const { label = '' } = props;
  switch (label) {
    case 'Enabled':
      return (
        <Chip
          size={'small'}
          label={'Enabled'}
          sx={{ border: '1px solid', color: '#00A666', backgroundColor: (theme) => theme.palette.chipBackground.low, p: '0px 6px', fontSize: '14px' }}
        />
      );
    case 'Disabled':
      return (
        <Chip
          size={'small'}
          label={'Disabled'}
          sx={{
            border: '1px solid #E4E6EC66',
            color: '#4E535D',
            backgroundColor: (theme) => theme.palette.chipBackground.high,
            p: '0px 6px',
            fontSize: '14px',
          }}
        />
      );
  }
};

export const TrueFalseChip = (props) => {
  const { label, trueValue } = props;
  if (label === trueValue)
    return (
      <Chip
        size={'small'}
        label={label}
        sx={{ border: '1px solid', color: '#00A666', backgroundColor: (theme) => theme.palette.chipBackground.low, p: '0px 6px', fontSize: '12px' }}
      />
    );
  return <Chip size={'small'} label={label} sx={{ border: '1px solid', backgroundColor: '#EC7A81', p: '0px 6px', fontSize: '12px' }} />;
};

export const TagsChip = (props) => {
  const { label } = props;
  return (
    <Chip
      size={'small'}
      label={label}
      sx={{
        border: '1px solid',
        borderColor: (theme) => theme.palette.gray10,
        p: 0,
        backgroundColor: (theme) => theme.palette.background.main,
        fontSize: '12px',
      }}
    />
  );
};

export const PaginationChip = (props) => {
  const { label } = props;
  return (
    <Chip
      label={label}
      sx={{
        borderColor: (theme) => theme.palette.light2,
        p: 0,
        backgroundColor: (theme) => theme.palette.light2,
        fontSize: '12px',
        height: '24px',
        fontWeight: '400',
        borderRadius: '8px',
      }}
    />
  );
};

export const safetyChip = (props) => {
  const { label = '' } = props;
const value = String(label).trim().toLowerCase();  
switch (value) {
    case 'safe':
      return (
        <Chip
          size={'small'}
          label={'Safe'}
          sx={{
            border: '1px solid #00A666',
            color: '#00A666',
            backgroundColor: (theme) => theme.palette.chipBackground.low,
            p: '0px 6px',
            fontSize: '14px',
          }}
        />
      );
    case 'unsafe':
      return (
        <Chip
          size={'small'}
          label={'Unsafe'}
          sx={{
            border: '1px solid #EC5962',
            color: '#EC5962',
            backgroundColor: (theme) => theme.palette.chipBackground.error,
            p: '0px 6px',
            fontSize: '14px',
          }}
        />
      );
  }
};
